module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Oberrohrdorf_AG-3f08151ec8e79f18716d84e00213482e.svg";